<div class="nav-container" [class.scrolled]="isScrolled" [class.opened]="isOpened">
    <div class="nav">
        <div class="nav-wrapper">
            <div class="navbar">
                <!--<div class="nav-item book-now d-none d-md-block" routerLink="/foglalas">Foglalj most</div>-->
                <div class="nav-item book-now d-none d-md-block" (click)="emailSender.email()">Foglalj most</div>
                <div class="navbar-brand mr-auto mx-md-auto brand-logo">
                    <img src="../../../assets/images/csak_felirat.png" alt="Logó" routerLink="/">
                </div>
                <div class="nav-item menu" [class.opened]="isOpened" #menuLink>
                    <div class="nav-link" #navLink (click)="isOpened = !isOpened">
                        <div class="text d-none d-md-block">
                            <div class="shadow-text">Bezárás</div>
                            <div class="visible-text">Menü</div>
                        </div>
                        <div class="hamburger">
                            <div class="ham-top"></div>
                            <div class="ham-mid"></div>
                            <div class="ham-bot"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="menu-container" [class.opened]="isOpened">
        <div class="menu-items">
            <div class="menu-item" #menuItem routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <span>Kezdőoldal</span>
            </div>
            <div class="menu-item" #menuItem routerLink="/rolunk" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <span>Rólunk</span>
            </div>
            <div class="menu-item" #menuItem routerLink="/kornyek" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <span>A környékről</span>
            </div>
            <div class="menu-item" #menuItem routerLink="/galeria" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <span>Galéria</span>
            </div>
            <!--<div class="menu-item" #menuItem routerLink="/kapcsolat" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <span>Kapcsolat</span>
            </div>-->
        </div>
        <div class="small-links">
            <!--<span routerLink="/sutikezelesi-szabalyzat" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Sütikezelési szabályzat</span>-->
            <!--<span routerLink="/hazirend" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Házirend</span>-->
            <span (click)="downloadPdf()">Házirend</span>
            <!--<span routerLink="/adatvedelmi-tajekoztato" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Adatvédelmi tájékoztató</span>-->
        </div>
    </div>
</div>